import styled from "styled-components";
const FlexBase = styled.div`
  display: flex;
  gap: ${({ theme, $gap }) => (Number.isFinite($gap) ? `${$gap}rem` : theme.spacings[$gap]) || theme.spacings.sm};
  justify-content: ${({ $justify }) => $justify || "flex-start"};
  flex-wrap: ${({ $wrap }) => $wrap ? "wrap" : "nowrap"};
  width: ${({ $width }) => $width || "100%"};

  & .form-group {
    width: 100%;
    margin-bottom: 0;
  }

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
export const Container = styled(FlexBase)`
  flex-direction: ${({ $direction }) => $direction};
  align-content: ${({ $alignContent }) => $alignContent || "normal"};
`;
export const Row = styled(FlexBase)`
  flex-direction: row;
  align-items: ${({ $align }) => $align || "flex-start"};
`;
export const Col = styled(FlexBase)`
  flex-direction: column;
  align-items: ${({ $align }) => $align || "flex-start"};
  min-width: 0;
  max-width: 100%;
`;
